function UserFactory($http, config) {
    const { baseUrl } = config;
    let User = null;
    let Token = null;

    try {
        Token = localStorage.getItem("tourists_token");
        User = JSON.parse(localStorage.getItem("tourists_user"));
    } catch (e) {
        Token = null;
        User = null;
    }

    const login = () =>
        new Promise((resolve, reject) => {
            FB.login(
                (result) => {
                    if (result.authResponse) {
                        return $http
                            .post(`${baseUrl}/api/auth/facebook`, {
                                access_token: result.authResponse.accessToken,
                            })
                            .then((response) => {
                                Token = response.headers("authorization");
                                User = response.data;

                                localStorage.setItem("tourists_token", Token);
                                localStorage.setItem(
                                    "tourists_user",
                                    JSON.stringify(User)
                                );

                                resolve();
                            })
                            .catch((err) => reject(err));
                    }
                    reject();
                    // }, { scope: 'public_profile, user_gender, user_birthday, user_hometown, user_likes, user_location' })
                },
                {
                    scope: "public_profile",
                }
            );
        });

    const logout = () => {
        Token = null;
        User = null;

        localStorage.removeItem("tourists_token");
        localStorage.removeItem("tourists_user");
        localStorage.removeItem("tourists_bookId");
    };

    const isLoggedIn = () => {
        return new Promise((resolve, reject) => {
            this.getCurrentUser()
                .then(() => resolve(true))
                .catch(() => reject());
        });
    };

    const getCurrentUser = () => {
        return new Promise((resolve, reject) => {
            if (User && Token) {
                resolve(User);
            } else if (Token) {
                $http
                    .get(`${baseUrl}/api/auth/me`)
                    .then((response) => {
                        const { user } = response;

                        User = user;

                        localStorage.setItem(
                            "tourists_user",
                            JSON.stringify(user)
                        );

                        resolve(user);
                    })
                    .catch((err) => reject(err));
            } else {
                resolve(null);
            }
        });
    };

    const getUser = () => User;

    return {
        login,
        logout,
        isLoggedIn,
        getCurrentUser,
        getUser,
    };
}

UserFactory.$inject = ["$http", "config"];

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js